import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
  {
    q: "Are your virtual medical assistants HIPAA compliant?",
    a: "Yes. Every VMA completes HIPAA training before placement, signs a BAA, works on encrypted, access-controlled systems, and undergoes quarterly compliance audits. We treat patient data with the same rigor as your in-house team.",
  },
  {
    q: "Which EHR systems do your assistants work in?",
    a: "Our VMAs are trained and certified on Epic, AthenaHealth, Cerner, eClinicalWorks, NextGen, and most major practice management platforms. During onboarding we train them on your exact SOPs and templates.",
  },
  {
    q: "Will my VMA work in my time zone?",
    a: "Absolutely. Your assistant works your clinic's hours — whether that is Eastern, Central, Mountain, or Pacific — and joins your existing phone system and team channels so patients never notice a difference.",
  },
  {
    q: "What happens if my VMA is sick or on leave?",
    a: "Full-Time Dedicated and Practice Fleet plans include backup VMA coverage at no extra cost. A trained reserve assistant steps in using your documented SOPs, so your front desk never misses a beat.",
  },
  {
    q: "How fast can we get started?",
    a: "Most practices are live within 48 hours of the consultation call: EHR credentials, phone routing, and SOP training are handled by your dedicated US account manager.",
  },
  {
    q: "Are there long-term contracts?",
    a: "No. Plans are month-to-month with a 30-day cancellation notice. Every engagement also includes a replacement guarantee — if the fit is not right, we rematch you at no charge.",
  },
];

export const FAQ = () => (
  <section id="faq" className="py-20 lg:py-28 bg-[#F3F2EB]/60" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <div className="flex justify-center">
          <Eyebrow>Common Questions</Eyebrow>
        </div>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight text-[#0F1E19]">
          Everything practices ask before switching.
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-[#E2E0D5] bg-white px-6 data-[state=open]:border-[#0A3B2C]/30"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-[#0F1E19] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-[#4A5D55]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
